// extracted by mini-css-extract-plugin
export default {"cardContainer":"planned-bid-contract_cardContainer__UjfhV","otherCardContainer":"planned-bid-contract_otherCardContainer__uLFbW"};